// relatorios.js
export const RELATORIOS_MAPEAMENTO = {
  "AnaliseCompostaComposed.jsx": "Análise Composta",
  "DateRangeFilter.jsx": "Filtro de Data",
  "EvolucaoDiariaChart.jsx": "Evolução Diária de NCEs",
  "EvolucaoFornecedoresStacked.jsx": "Evolução Diária dos Principais Fornecedores",
  "FilterPeriodBar.jsx": "Cards de Status",
  "RankingDefeitosChart.jsx": "Ranking de Defeitos",
  "RankingFornecedoresChart.jsx": "Ranking de Fornecedores",
  "SeveridadePorEmbalagemChart.jsx": "Severidade por Embalagem",
  "StatusEtapasRadar.jsx": "Distribuição das NCEs por Etapa",
  "TiposEmbalagensChart.jsx": "Tipos de Embalagens",
  "UnidadesPieChart.jsx": "Unidades que abriram NCE"
};

// Lista de opções para exibição
export const RELATORIOS_OPCOES = Object.values(RELATORIOS_MAPEAMENTO);

// Lista de arquivos (como está no banco)
export const RELATORIOS_ARQUIVOS = Object.keys(RELATORIOS_MAPEAMENTO);

// Função helper para converter nome do arquivo para nome amigável
export const getNomeAmigavel = (nomeArquivo) => RELATORIOS_MAPEAMENTO[nomeArquivo] || nomeArquivo;

// Função helper para converter nome amigável para nome do arquivo
export const getNomeArquivo = (nomeAmigavel) => {
  const entrada = Object.entries(RELATORIOS_MAPEAMENTO)
    .find(([_, valor]) => valor === nomeAmigavel);
  return entrada ? entrada[0] : nomeAmigavel;
};